module.exports = __webpack_public_path__ + "img/Abkhazia.6eeb940d.png";